import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const pdfViewerV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Pdf Viewer element to v2 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'pdfViewer'>): void => {
    if (props?.style?.label?.color && !props?.content?.title?.iconColor) {
      const currentColor = props.style.label.color.color1;
      props.content = {
        ...props.content,
        title: {
          ...props.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
